import { VIEWS_SUB_SCREENS, useViewSubScreen } from 'reducers/viewsSlice';
import { checkUserIsHRISManager } from 'utils/helpers/rolesAccess';

import { TeamFilled } from 'assets/assetsV1/iconComponents';
import { ColumnFilter } from 'assets/assetsV1/iconComponents/ColumnFilter';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

const SavePageHeader = () => {
  const subTitle = checkUserIsHRISManager()
    ? 'This view will be saved with the selected user filters and will be available only across Goals/Initiatives pages'
    : 'This view will be applied across all modules';

  return (
    <ListItemComp
      title="Save your view"
      subTitle={subTitle}
      LeftComponent={TeamFilled}
      withoutBackground
      padding="16px 24px"
    />
  );
};

const ApplyFiltersHeader = () => (
  <ListItemComp
    withoutBackground
    padding="16px 24px"
    title="Apply Filters"
    // subTitle={'Meta Info'}
    LeftComponent={ColumnFilter}
  />
);

export const ModalHeader = () => {
  const viewsScreen = useViewSubScreen();

  if (viewsScreen === VIEWS_SUB_SCREENS.UPLOAD_CSV) {
    return null;
  }

  if (viewsScreen === VIEWS_SUB_SCREENS.SAVE) {
    return <SavePageHeader />;
  }

  return <ApplyFiltersHeader />;
};
